
  export default {
    name: 'Homepage',
    components: {},
    data () {
      return {
        activeIndex: '1',
        isB: true,
        isC: false,
        switchBthText: 'Job seeker',
        isHome: true,
        isHomepage: true,
        isDownload: false,
        isRecruiters: true,
        downloadUrlApple: 'https://hireyapp.onelink.me/7R9y/u9ecpcu2',
        downloadUrlGoogle: 'https://hireyapp.onelink.me/7R9y/f1unye34',
        downloadAddress: 'https://hireyapp.onelink.me/7R9y/r6k1ru5w',
        searchText: '',
        mobileNumber: '',
        getAppUnderline: '',
        getAppUnderline02: '',
        getAppUnderline03: '',
        getAppUnderline04: '',
      }
    },
    mounted () {
      if (window.location.href.indexOf('/jobSeeker') > -1) {
        this.switchBthText = 'Recruiter'
      } else {
        this.switchBthText = 'Job seeker'
      }
      if (window.location.href.indexOf('/download') > -1) {
        this.pageBthDownload()
      }
      window.addEventListener('popstate', this.popstate, false)
    },
    destroyed () {
      window.removeEventListener('popstate', this.popstate, false)
    },
    methods: {
      getAppMouseover() {
        this.getAppUnderline = 'box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.2)'
      },
      getAppMouseover2() {
        this.getAppUnderline02 = 'box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.2)'
      },
      getAppMouseover3() {
        this.getAppUnderline03 = 'box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.2)'
      },
      getAppMouseover4() {
        this.getAppUnderline04 = 'box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.2)'
      },
      getAppMouseleave() {
        this.getAppUnderline = ''
        this.getAppUnderline02 = ''
        this.getAppUnderline03 = ''
        this.getAppUnderline04 = ''
      },
      getHireyApp() {
        gtag('event', 'jobpage_gethirey_click')
        window.open(this.downloadAddress, '_blank')
      },
      switchBth () {
        if (window.location.href.indexOf('/jobSeeker') > -1) {
          this.switchBthText = 'Job seeker'
          this.$router.push('/recruiter')
        } else {
          this.switchBthText = 'Recruiter'
          this.$router.push('/jobseeker')
        }
        console.log(window.location.href.indexOf('/recruiter'))
      },
      pageBthHomepage () {
        this.isHome = true
        // this.$router.push('/recruiter')
        this.isHomepage = true
        this.isDownload = false
        this.switchBthText = 'Job seeker'
      },
      pageBthDownload () {
        this.isHome = false
        this.$router.push('/download')
        this.isHomepage = false
        this.isDownload = true
        // this.$router.push('/download')
      },
      popstate () {
        if (window.location.href.indexOf('/download') > -1) {
          this.isHome = true
          this.isHomepage = true
        } else {
          this.isHome = true
          this.isHomepage = true
        }
        if (window.location.href.indexOf('/recruiter') > -1) {
          this.switchBthText = 'Job seeker'
        } else {
          this.switchBthText = 'Recruiter'
        }
      },
      roleChangeBth(role) {
        if (role === 'Recruiters') {
          this.isRecruiters = true
        } else {
          this.isRecruiters = false
        }
        console.log(role)
      },
      downloadBth (url) {
        if (url === this.downloadUrlApple) {
          gtag('event', 'jobpage_appstore_click' )
          window.open(url, '_blank')
        } else if (url === this.downloadUrlGoogle) {
          gtag('event', 'jobpage_googleplay_click' )
          window.open(url, '_blank')
        }
      },
      searchMobile () {
        this.mobileNumber = '+1' + this.searchText
        console.log('searchMobile=====>', this.mobileNumber)
    }
  
    },
  
  }
  